export const environment = {
  production: false,
  apiUrl: 'https://foodies-api.fstk.run.place',
};

